import { useTelemetryViewEvent } from 'common/hooks';
import {
  merchantAdminPurchasesView,
  merchantAdminPurchasesInteractionDownloadCsv,
  merchantAdminPurchasesInteractionGetReceipts,
  merchantAdminPurchasesInteractionSwitchToItems,
  merchantAdminPurchasesInteractionSwitchToOrders,
  merchantAdminPurchasesInteractionDownloadCsvConfirmed,
  merchantAdminPurchasesInteractionGetReceiptsConfirmed,
} from 'core/telemetry/avo/Avo';

export const useTelemetryMerchantAdminPurchasesViewTracking = () => {
  useTelemetryViewEvent('merchantAdminPurchasesView', {}, durationMs =>
    merchantAdminPurchasesView({ durationMs, viewType: 'venue' }),
  );
};

export const telemetryMerchantAdminPurchasesInteractionDownloadCsv = () => {
  merchantAdminPurchasesInteractionDownloadCsv();
};

export const telemetryMerchantAdminPurchasesInteractionGetReceipts = () => {
  merchantAdminPurchasesInteractionGetReceipts();
};

export const telemetryMerchantAdminPurchasesInteractionSwitchToItems = () => {
  merchantAdminPurchasesInteractionSwitchToItems();
};

export const telemetryMerchantAdminPurchasesInteractionSwitchToOrders = () => {
  merchantAdminPurchasesInteractionSwitchToOrders();
};

export const telemetryMerchantAdminPurchasesInteractionDownloadCsvConfirmed = () => {
  merchantAdminPurchasesInteractionDownloadCsvConfirmed();
};

export const telemetryMerchantAdminPurchasesInteractionGetReceiptsConfirmed = () => {
  merchantAdminPurchasesInteractionGetReceiptsConfirmed();
};
